
import React from "react";

const FAQ = () => {
  return (
    <div className="container mt-5">
      <h2>❓ Frequently Asked Questions</h2>

      <div className="mt-4">
        <h5>1. How do I create an AI Agent?</h5>
        <p>Go to the AI Agent Manager and click "Create". Fill out the agent name, role, data source, and prompt. Save to activate.</p>
      </div>

      <div className="mt-4">
        <h5>2. Can I duplicate a workflow?</h5>
        <p>Currently, there is no direct "duplicate" button, but you can create a new workflow and reuse the steps manually or export/import the workflow JSON.</p>
      </div>

      <div className="mt-4">
        <h5>3. How does rollback work?</h5>
        <p>Rollback allows you to revert a workflow template to its previous version. Rollbacks are logged and can be audited.</p>
      </div>

      <div className="mt-4">
        <h5>4. What permissions are required for different users?</h5>
        <p>Admins have full access, including rollback and user management. PMs can manage projects and workflows. Agents have limited access to assigned tasks only.</p>
      </div>

      <div className="mt-4">
        <h5>5. Where is my data stored?</h5>
        <p>All data is securely stored in your cloud backend (MySQL + Dockerized API). Data retention policies can be managed under Settings.</p>
      </div>

      <div className="mt-4">
        <h5>6. Can I get AI suggestions automatically?</h5>
        <p>Yes. Enable AI Copilot and use the Dashboard to view smart suggestions based on active tasks, delays, and automation triggers.</p>
      </div>
    </div>
  );
};

export default FAQ;
